import { IStoreState } from "interfaces/storeState";
import { createRequestErrorSelector, createRequestFetchingSelector } from "store/requests/selectors";

import { CreditCardRequestFetchingSelectorsNames } from "./actions";

export const getIsSavingCreditCard = (state: IStoreState): boolean =>
  createRequestFetchingSelector([CreditCardRequestFetchingSelectorsNames.ADD_CREDIT_CARD_REQUEST])(state);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCreditCardError = (state: IStoreState): any =>
  createRequestErrorSelector([CreditCardRequestFetchingSelectorsNames.ADD_CREDIT_CARD_REQUEST])(state);
